<script>
	// Components
	import Modal from '@/Components/Modal.svelte';
	import Label from '@/Components/Label.svelte';
	// Partials
	import DeductionRow from '@/Partials/Racing/Selections/_DeductionRow.svelte';
	// Stores
	import SelectionStore from '@/Stores/Racing/SelectionStore.js';
	import { editDeductionsOpen } from '@/Stores/Store.js';
	// Constants
	import { SelectionStatus } from '@/Constants/Selection.js';

	export let race;
	export let meeting;
</script>

{#if $editDeductionsOpen && race}
	<Modal on:close={() => editDeductionsOpen.set(false)} className="mx-2 md:w-2/3 md:mx-auto">
		<div class="pt-2 text-center" slot="header">
			<div class="font-semibold uppercase">
				{`Edit deductions for Race ${race && race.race_number} @ ${meeting && meeting.name}`}
			</div>
			<div class="mt-1 text-md">
				Race status:
				<Label label={race.status.name} classes="ml-1 w-12 inline" />
				{#if race.in_review}
					<Label label="In Review" classes="ml-1 w-12 inline" />
				{/if}
			</div>
		</div>
		<!-- ALL RACES -->
		<div class="table w-full px-4 mt-2 mb-4 text-left table-auto">
			<div class="table-row-group">
				<div class="table-row font-bold uppercase">
					<div class="table-cell px-1 py-2">Selection</div>
					<div class="table-cell px-1 text-center">Deductions (in cents)</div>
				</div>
			</div>
			<div class="table-row-group">
				{#each $SelectionStore
					.where('race_id', race.id)
					.where('status.id', '!==', SelectionStatus.Active)
					.sortBy('number')
					.all() as selection (selection.id)}
					<DeductionRow {selection} {race} />
				{/each}
			</div>
		</div>
		<div class="py-2 text-sm italic text-right">Note: race must be In-Review to allow updates</div>
	</Modal>
{/if}
